import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'

interface UnconnectedChannelsModalProps {
  onConfirm: () => void
  onBack: () => void
}

export const UnconnectedChannelsModal = ({ onConfirm, onBack }: UnconnectedChannelsModalProps) => {
  const { closeModal } = useModals()
  const handleConfirm = () => {
    closeModal()
    onConfirm()
  }

  const handleBack = () => {
    onBack()
  }

  return (
    <Modal.Root aria-labelledby="modal-heading" size="sm">
      <Modal.Header title="Unconnected channels detected" />
      <Modal.Content>
        <Text variant="secondary">
          Content for unconnected channels will be saved to as drafts but not posted online.
        </Text>
      </Modal.Content>

      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton onPress={handleBack} size="lg" variant="tertiary">
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>

        <Modal.FooterContent slot="right">
          <Modal.FooterButton onPress={handleConfirm} size="lg" variant="primary">
            Continue Anyway
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
